<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import { ChevronDown } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useDialog } from '@/composables/useDialog'
import { rejectLoanApplicationPath } from '@/routes'

interface Props {
  applicationId: string
  reasons: Record<string, string>
}

const props = defineProps<Props>()

const { confirm } = useDialog()

async function confirmReject(label: string) {
  const ok = await confirm({
    title: 'Reject application?',
    description: label,
    confirmLabel: 'Reject',
    variant: 'destructive',
  })
  if (!ok) return
  router.post(rejectLoanApplicationPath(props.applicationId), { reason: label }, { preserveScroll: true })
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        size="sm"
        variant="destructive"
        class="w-full justify-between"
      >
        Reject Application
        <ChevronDown class="size-3.5 opacity-75" />
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end" class="w-64">
      <DropdownMenuLabel class="text-xs font-normal text-muted-foreground">
        Select rejection reason
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem
          v-for="[key, label] in Object.entries(reasons)"
          :key="key"
          class="text-destructive focus:text-destructive"
          @click="confirmReject(label)"
        >
          {{ label }}
        </DropdownMenuItem>
      </DropdownMenuGroup>
    </DropdownMenuContent>
  </DropdownMenu>

</template>
